module.exports = __webpack_public_path__ + "img/logo-twitter.ed27f880.png";